<template>
  <div class="Melamine">
    <div class="title">Triethylene glycol
</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="InspectionItem" label="Inspection Item" width="300">
        </el-table-column>
        <el-table-column prop="Unit" label="Unit">
        </el-table-column>
        <el-table-column prop="QualityIndicator" label="Quality Indicator">
        </el-table-column>
         <!-- <el-table-column prop="Result" label="Result">
        </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>230kg/drum;18.4mt/20°FCL, 27.6mt/40 FCL</p>
    </div>
    <div class="item-huanhang">
      <label>Applications:</label>
      <p>
       Mainly used as a superior solvent in electrical and fine chemical itndustry.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {InspectionItem:"Appearance",  Unit:"-",    QualityIndicator:"Colorless or light yellowtransparent viscous liquid",  Result:"Pass" },
        {InspectionItem:"Ethylene Glycol (MEG)",  Unit:"%(m/m)",    QualityIndicator:"-",  Result:"0.05" },
        {InspectionItem:"Di ethylene Glycol(DEG)",  Unit:"%(m/m)",    QualityIndicator:"-",  Result:"0.15" },
        {InspectionItem:"Triethylene Glycol (TEG)",  Unit:"%(m/m)",    QualityIndicator:">=99.0",  Result:"99.58" },
        {InspectionItem:"Tetra ethyleneGlycol(TTEG)",  Unit:"%(m/m)",    QualityIndicator:"-",  Result:"<0.02" },
        {InspectionItem:"Colour",  Unit:"(pt-co)/scale",    QualityIndicator:"<2=5",  Result:"15" },
        {InspectionItem:"Water",  Unit:"%(m/m)",    QualityIndicator:"<=0.10",  Result:"0.021" },
        {InspectionItem:"Density(20°C)",  Unit:"g/c m2",    QualityIndicator:"1.122~1.124",  Result:"1.1237" },
        {InspectionItem:"Ash",  Unit:"%(m/m)",    QualityIndicator:"<=0.01",  Result:"0.0015" },
        {InspectionItem:"Acidity (as Acetic Acid)",  Unit:"mg/kg",    QualityIndicator:"<=50",  Result:"7.7" },
        
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
